/// <reference path="../../types.d.ts" />
import { commonActions } from '@codametrix/ui-common';
import { connect } from 'react-redux';
import { activeProcessId, getBPMDetails } from '../../actions/bpm-steps.action';
import { buildDispatchable } from '../../actions/_action-utilities';
import { BPMStepsApp } from './bpm-steps-app';
import { authenticationChannel } from '@codametrix/ui-common';
const mapStateToProps = function(state) {
    return {
        ...state.steps
    };
};
const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        registerActivity: ()=>{
            authenticationChannel.postMessage({
                type: commonActions.AuthenticatedWindow.ACTIVITY,
                payload: true,
                meta: {
                    suppressRedux: true
                }
            });
        },
        getBPMDetails: async (urlParams)=>{
            await authenticationChannel.ready;
            runDispatchable(()=>{
                return dispatch(getBPMDetails(urlParams));
            });
        },
        setActiveProcessId: (processId)=>{
            dispatch(activeProcessId(processId));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(BPMStepsApp);
